import { PipeTransform, Pipe } from "../../../node_modules/@angular/core";

@Pipe({
    name: 'cardnumber'
})

export class CardMaskPipe implements PipeTransform {
    transform(cardNumber: string) {
        if (cardNumber) {
            return cardNumber.substring(0, 4) + '-'
                + cardNumber.substring(4, 8) + '-'
                + cardNumber.substring(8, 12) + '-'
                + cardNumber.substr(12, cardNumber.length);
        } else {
            return null;
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/utilities/CardMaskPipe.ts